var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeySwap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60496 11.8948L5.51996 13.9873C5.37746 14.1373 5.37746 14.3698 5.51996 14.5198L7.60496 16.6123C7.83746 16.8523 8.24246 16.6798 8.24246 16.3498V14.9998H12.75C13.1625 14.9998 13.5 14.6623 13.5 14.2498C13.5 13.8373 13.1625 13.4998 12.75 13.4998H8.24246V12.1573C8.24246 11.8198 7.83746 11.6548 7.60496 11.8948ZM18.4875 9.48726L16.4025 7.39476C16.17 7.15476 15.765 7.32726 15.765 7.65726V8.99976H11.25C10.8375 8.99976 10.5 9.33726 10.5 9.74976C10.5 10.1623 10.8375 10.4998 11.25 10.4998H15.7575V11.8423C15.7575 12.1798 16.1625 12.3448 16.395 12.1048L18.48 10.0123C18.63 9.86976 18.63 9.62976 18.4875 9.48726Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeySwap);
export default __webpack_public_path__ + "static/media/key_swap.742ab847681fd494aa49a935d7867652.svg";
export { ForwardRef as ReactComponent };